import axios from 'axios';

const AddressApi = {
  getAddress: async (token) => {
    try {
      const response = await axios.get(`${process.env.API_URL}/api/v1.0/user/address`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      return error;
    }
  },
  addAddress: async (token, payload) => {
    try {
      await axios.post(`${process.env.API_URL}/api/v1.0/user/address`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.log(error);
    }
  },
  deleteAddress: async (token, id) => {
    try {
      await axios.delete(`${process.env.API_URL}/api/v1.0/user/address/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.log(error);
    }
  },
  updateAddress: async (token, id, payload) => {
    try {
      await axios.patch(`${process.env.API_URL}/api/v1.0/user/address/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.log(error);
    }
  },
  getAddressById: async (token, id) => {
    try {
      const response = await axios.get(`${process.env.API_URL}/api/v1.0/user/address/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  },
};

export default AddressApi;
